import { Tag } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface IHotkeysListProps {
   
}
const HotkeysList = (props: IHotkeysListProps): JSX.Element => {
    return <div className='pe-hot-keys-list container py-4'>
       {
            hotkeys().map((hotkey:IHotKeyData) => {
                return <div key={hotkey.id} className="row">
                    <div className="col-md-8">
                        { __( hotkey.title ) }
                    </div>
                    <div className="col-md">
                        <Tag minimal className="px-2 py-0 mb-1">
                            <div className="smallest title text-uppercase">
                                { 
                                    [   
                                        hotkey.ctrl   ? "CTRL"   : "", 
                                        hotkey.shift  ? "SHIFT"  : "", 
                                        hotkey.alt    ? "ALT"    : "" 
                                    ]
                                     .filter((m: string) => !!m)
                                     .join(" + ")  
                                } + 
                                <span className="pl-1">{ hotkey.key }</span>
                            </div>
                        </Tag>
                    </div>
                </div>
            } )
       }
    </div>
}
export default HotkeysList

export interface IHotKeyData {
    id: string
    title: string
    key: string
    alt: boolean
    ctrl: boolean
    shift: boolean
}
export const hotkeys = (): IHotKeyData[] => {
    return [
        {
            id: "panels",
            title: "Show panels",
            key: "p",
            alt: true,
            ctrl: false,
            shift: false
        },
        {
            id: "top-panel",
            title: "Show top panel",
            key: "t",
            alt: true,
            ctrl: false,
            shift: false
        },
        {
            id: "tools",
            title: "Show tools",
            key: "o",
            alt: true,
            ctrl: false,
            shift: false
        },
        {
            id: "hotkeys",
            title: "Show hotkeys",
            key: "h",
            alt: true,
            ctrl: false,
            shift: false
        },
        {
            id: "page-settings",
            title: "Page settings",
            key: "a",
            alt: true,
            ctrl: false,
            shift: false
        },
        {
            id: "editor-settings",
            title: "Editor settings",
            key: "s",
            alt: true,
            ctrl: false,
            shift: false
        },
        {
            id: "undo",
            title: "Undo",
            key: "z",
            alt: false,
            ctrl: true,
            shift: false
        },
        {
            id: "redo",
            title: "Redo",
            key: "z",
            alt: false,
            ctrl: true,
            shift: true
        },
        {
            id: "",
            title: "Change editor|viewer mode",
            key: "v",
            alt: false,
            ctrl: true,
            shift: true
        }, 
        {
            id: "edit-mode",
            title: "Edit mode",
            key: "e",
            alt: false,
            ctrl: true,
            shift: false
        },
        {
            id: "inner-mode",
            title: "Inner edit mode",
            key: "i",
            alt: false,
            ctrl: true,
            shift: false
        },
        {
            id: "transform-mode",
            title: "Transform mode",
            key: "p",
            alt: false,
            ctrl: true,
            shift: false
        },
        {
            id: "drag",
            title: "Drag page mode",
            key: "d",
            alt: false,
            ctrl: true,
            shift: false
        },
        {
            id: "sections-panel",
            title: "Show editor settings",
            key: "s",
            alt: true,
            ctrl: false,
            shift: false
        },
        {
            id: "page-settings-panel",
            title: "Show page settings",
            key: "p",
            alt: true,
            ctrl: false,
            shift: false
        },
        {
            id: "reset-transformation",
            title: "Reset transforms of selected element.",
            key: "r",
            alt: false,
            ctrl: true,
            shift: false
        },
        {
            id: "copy-landing",
            title: "Copy Landing data to clipboard",
            key: "r",
            alt: false,
            ctrl: true,
            shift: false
        },
        // {
        //     id: "",
        //     title: "Redo",
        //     key: "",
        //     alt: false,
        //     ctrl: false,
        //     shift: false
        // },
    ]
}